import(/* webpackMode: "eager" */ "/vercel/path0/app/(website)/page.tsx");
